/* GENERATED BY art-src/make_arena.py --realm - DO NOT EDIT.
 *
 * One board per realm. The ORIGINAL declared six arena themes and pointed every one of
 * them at the SAME two assets (Background_All + Gameboard_Rust), so there was nothing to
 * copy - these are ours. A realm accents its board with the same colour its cards are
 * framed in, read from RevivalTheme.cs by stage_card_frames.realm_colours().
 */
import type { BoardTheme } from "./match/boardTheme";

export const REALM_BOARDS: readonly BoardTheme[] = Object.freeze([
  { id: "Domain_of_Negafook", name: "Domain of Negafook", surface: "/art/board/Domain_of_Negafook/surface.webp", inset: 0.02, scrim: 0.34 },
  { id: "The_Ironworks", name: "The Ironworks", surface: "/art/board/The_Ironworks/surface.webp", inset: 0.02, scrim: 0.34 },
  { id: "The_Scorched_Expanse", name: "The Scorched Expanse", surface: "/art/board/The_Scorched_Expanse/surface.webp", inset: 0.02, scrim: 0.34 },
  { id: "The_Verdant_Hollow", name: "The Verdant Hollow", surface: "/art/board/The_Verdant_Hollow/surface.webp", inset: 0.02, scrim: 0.34 },
] as BoardTheme[]);
